
export default {
    name: 'LeeSlide',
    inheritAttrs: false,
    data() {
        return {
            newSize: '',
            newTheme: '',
            down: false,//是否按下
            downs: [false, false],//是否按下
            over: false,//
            overs: [false, false],//
            oldx: 0,
            posx: 0,//滑块的位置
            posxs: [0, 0],//滑块的位置
            fullw: 0,
            savex: 0,//拖动后保存位置
            savexs: [0, 0],//拖动后保存位置
            stops: [],
            xh: 0
        }
    },
    methods: {
        toFix(num) {
            return num.toFixed(0)
        },
        chuli() {
            for (let i = 1; i < (this.max - this.min) / this.step; i++) {
                this.stops.push(i * (this.step))
            }
            if (this.oldx === 0) {//并且没有滑动过
                if (!this.range) {
                    this.posx = this.value
                    this.savex = this.posx
                } else {
                    for (let i = 0; i < this.value.length; i++) {
                        this.$set(this.posxs, i, this.value[i])
                        this.$set(this.savexs, i, this.value[i])
                    }
                }
            }
            document.addEventListener('mousemove', (e) => {
                let mm = Math.round((e.pageX - this.oldx) / this.fullw * 100)
                if (!this.range) {
                    if (this.down && mm % this.step === 0) {
                        this.posx = this.savex + mm
                        if (this.posx >= 100) {
                            this.posx = 100
                        }
                        if (this.posx <= 0) {
                            this.posx = 0
                        }
                        this.$emit('input', this.posx)
                    }
                } else {
                    if (this.downs[this.xh] && mm % this.step === 0) {
                        this.$set(this.posxs, this.xh, this.savexs[this.xh] + mm)
                        for (let i = 0; i < this.posxs.length; i++) {
                            if (this.posxs[i] >= 100) {
                                this.posxs[i] = 100
                            }
                            if (this.posxs[i] <= 0) {
                                this.posxs[i] = 0
                            }
                        }
                        this.$emit('input', this.posxs)
                    }
                }

            })
            document.addEventListener('mouseup', (e) => {
                if (!this.range) {
                    this.down = false
                    this.savex = this.posx
                } else {
                    this.$set(this.downs, this.xh, false)
                    this.$set(this.savexs, this.xh, this.posxs[this.xh])
                }
            })
            document.addEventListener('touchmove', (e) => {
                let mm = Math.round((e.targetTouches[0].pageX - this.oldx) / this.fullw * 100)
                if (!this.range) {
                    if (this.down && mm % this.step === 0) {
                        this.posx = this.savex + mm
                        if (this.posx >= 100) {
                            this.posx = 100
                        }
                        if (this.posx <= 0) {
                            this.posx = 0
                        }
                        this.$emit('input', this.posx)
                    }
                } else {
                    if (this.downs[this.xh] && mm % this.step === 0) {
                        this.$set(this.posxs, this.xh, this.savexs[this.xh] + mm)
                        for (let i = 0; i < this.posxs.length; i++) {
                            if (this.posxs[i] >= 100) {
                                this.posxs[i] = 100
                            }
                            if (this.posxs[i] <= 0) {
                                this.posxs[i] = 0
                            }
                        }
                        this.$emit('input', this.posxs)
                    }
                }
            })
            document.addEventListener('touchend', (e) => {
                if (!this.range) {
                    this.down = false
                    this.savex = this.posx
                } else {
                    this.$set(this.downs, this.xh, false)
                    this.$set(this.savexs, this.xh, this.posxs[this.xh])
                }
            })
        },
        huadao() {
            if (!this.range) {
                let offsetLeft = event.currentTarget.getBoundingClientRect().x
                this.posx = this.savex = Math.round((event.pageX - offsetLeft) / this.fullw * 100)
                this.$emit('input', this.posx)

            }
        },
        mhuadao() {
            if (!this.range) {
                let offsetLeft = event.currentTarget.getBoundingClientRect().x
                this.posx = this.savex = Math.round((event.targetTouches[0].pageX - offsetLeft) / this.fullw * 100)
                this.$emit('input', this.posx)
            }
        },
        mouseenter(xh) {
            if (typeof (xh) === 'object') {
                this.over = true
            } else {
                this.$set(this.overs, xh, true)
            }

        },
        mouseleave(xh) {
            if (typeof (xh) === 'object') {
                this.over = false
            } else {
                this.$set(this.overs, xh, false)
            }
        },
        mousedown(xh) {
            this.xh = xh
            if (typeof (xh) === 'object') {
                this.down = true
            } else {
                this.$set(this.downs, xh, true)
            }
            this.oldx = event.pageX
        },
        mouseup() {
            if (!this.range) {
                this.down = false
                this.savex = this.posx
            } else {
                //this.$set(this.downs, this.xh, false)
                //this.$set(this.savexs, this.xh, this.posxs[this.xh])
            }
        },
        touchstart(xh) {
            this.xh = xh
            if (typeof (xh) === 'object') {
                this.down = true
            } else {
                this.$set(this.downs, xh, true)
            }
            this.oldx = event.targetTouches[0].pageX
        },
    },
    mounted() {
        //
        this.fullw = this.$refs['lee-slide'].offsetWidth

        this.chuli()
        window.addEventListener('resize', (e) => {
            if (this.$refs['lee-slide']) {
                this.fullw = this.$refs['lee-slide'].offsetWidth
                this.chuli()
            }
        })
        //如果参数乱写
        let AllTheme = 'red,yellow,black,green,blue';
        let AllSize = 's,m,l';
        if (AllTheme.indexOf(this.theme) == -1) {
            this.newTheme = 'blue'
        } else {
            this.newTheme = this.theme
        }
        if (AllSize.indexOf(this.size) == -1) {
            this.newSize = 'm'
        } else {
            this.newSize = this.size
        }

    },
    computed: {
        slideListeners() {
            return Object.assign({}, this.$listeners, {
                mousedown: (event) => {
                    this.$emit('mousedown', event);
                },
                mouseup: (event) => {
                    this.$emit('mouseup', event);
                },
            })
        },
        classObject() {
            return this.newSize + ' ' + this.newTheme
        }
    },
    props: {
        theme: {
            type: String,
            default: 'blue' //默认default
        },
        size: {
            type: String,
            default: 'm' //默认default
        },
        value: [Number, Array],
        // initValue: {
        //     type: Number,
        //     default: 0//默认default
        // },
        showTip: {
            type: Boolean,
            default: true//默认default
        },
        min: {
            type: Number,
            default: 0//默认default
        },
        max: {
            type: Number,
            default: 100//默认default
        },
        step: {
            type: Number,
            default: 1//默认default
        },
        showStop: {
            type: Boolean,
            default: false//默认default
        },
        noDrag: {
            type: Boolean,
            default: false//默认default
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                if (typeof (value) === 'number') {
                    this.range = false
                    this.posx = this.value//很关键
                    if (!this.down) {
                        this.savex = this.posx//很关键
                    }
                } else {
                    this.range = true
                }
            }
        }
    },
};
